module.exports = __webpack_public_path__ + "static/media/image-john.9c159506.jpg";